import { Component, Input } from '@angular/core';
import { Advert } from 'interfaces/common';

@Component({
  selector: 'app-select-days',
  templateUrl: './select-days.component.html',
  styleUrls: ['./select-days.component.scss'],
})
export class SelectDaysComponent {
  @Input() product!: Advert;

  days = [
    'monday',
    'tuesday',
    'wednesday',
    'thursday',
    'friday',
    'saturday',
    'sunday',
  ] as const;

  getSlotData(day: (typeof this.days)[number]): Advert['mondayHours'] {
    return this.product?.[
      (day + 'Hours') as keyof Advert
    ] as Advert['mondayHours'];
  }

  isWorkingDay(day: (typeof this.days)[number]) {
    return this.product?.[day];
  }

  anyScheduleExists() {
    return this.days.some(day => this.isWorkingDay(day));
  }

  isSlotAvailable(day: (typeof this.days)[number]) {
    return this.getSlotData(day)?.some(d => d.startHour && d.endHour);
  }
}
